(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Qsched_typeDetailController', Qsched_typeDetailController);

    Qsched_typeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Qsched_type'];

    function Qsched_typeDetailController($scope, $rootScope, $stateParams, previousState, entity, Qsched_type) {
        var vm = this;

        vm.qsched_type = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:qsched_typeUpdate', function(event, result) {
            vm.qsched_type = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
